import React, { useEffect, useState } from "react";
import Header from "../common/Header";
import $ from "jquery";
import { Link, useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import Select from "react-select";
import { dateFormat } from "../helpers/date";
import { convertDataToWarehouseSheet } from "../helpers/print";
import EnterOrderList from "./EnterOrderList";
import Toastify from "../common/Toastify";
import { GETREQUEST, POSTREQUEST } from "../helpers/ServiceRequest";
import { generateWarehousePdf } from "../Pdfs/warehouseSheet";

function EnterOrder() {
  const [orderDate, setOrderDate] = useState(dateFormat);
  const [customerCodeValue, setCustomerCodeValue] = useState("");
  const [customerId, setcustomerId] = useState("");
  const [customerNameValue, setCustomerNameValue] = useState("");
  const [customerCategory, setCustomerCategory] = useState("");
  const [units, setUnits] = useState([]);
  const [agents, setAgents] = useState([]);
  const [BuyerCode, setBuyerCode] = useState("");
  const [contactName, setContactName] = useState("");
  const [phoneNo, setPhoneNo] = useState("");
  const [poNumber, setPoNumber] = useState("");
  const [orderNotes, setOrderNotes] = useState("");
  const [customeCodeErr, setCustomeCodeErr] = useState(false);
  const [customerNameErr, setCustomerNameErr] = useState(false);
  const [deliveryInstructions, setDeliveryInstructions] = useState("");
  const [orderItemsList, setOrderItemsList] = useState([]);
  const [orderDErr, setOrderDErr] = useState(false);
  const [customersCode, setCustomersCode] = useState([]);
  const [products, setProducts] = useState([]);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const [disabledBtn, setDisabledBtn] = useState(false);

  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    var headerHeight = $("header").outerHeight();
    var mainHeight = $(window).height() - headerHeight;
    $("main").height(mainHeight);
    $("main").css("margin-top", headerHeight + "px");
  });

  useEffect(() => {
    if (customerId) {
      let commanURL =
        process.env.REACT_APP_API_URL + "/get-comman-all-for-product";
      let PURL =
        process.env.REACT_APP_API_URL + `/search-order-product/${customerId}`;

      const getCommonData = async () => {
        let response = await GETREQUEST(commanURL, user.jwtToken)
        if (response?.data) {
          let data = response.data;
          let agentList = [];
          data.agent.forEach((item) => {
            agentList = [...agentList, { label: item.AgentCode, value: item.AgentID }];
          });
          setAgents(agentList);

          let unitList = [];
          data.units.forEach((item) => {
            unitList = [...unitList, { label: item.UnitName, value: item.UnitID }];
          });
          setUnits(unitList);
        }
      }

      const getProducts = async () => {
        let response = await GETREQUEST(PURL, user.jwtToken)
        if (response?.data) {
          setProducts(response.data)
        }
      }
      getCommonData();
      getProducts();
    }
  }, [customerId]);

  useEffect(() => {
    fetchCustomers();
    const curentSelectedCustomer = customersCode.find((customerData) => customerData.value == customerCodeValue.value);
    if (curentSelectedCustomer != undefined && curentSelectedCustomer.tblOrders[0]?.OrderId != null) {
      navigate(`/view-edit-order/${curentSelectedCustomer.tblOrders[0]?.OrderId}`)
    }
  }, [orderDate]);


  // fetch Customers Function
  const fetchCustomers = async () => {
    let URL = process.env.REACT_APP_API_URL + `/search-customer?orderDate=${orderDate}`;
    let response = await GETREQUEST(URL, user.jwtToken)
    if (response?.data) {
      let cnList = [];
      let ccList = [];
      let data = response.data;
      data.forEach((item) => {
        cnList = [...cnList, { label: item.CustomerName, value: item.CustomerID, ...item }];
        ccList = [...ccList, { label: item.CustomerCode, value: item.CustomerID, ...item }];
      });
      setCustomersCode(ccList);
    }
  }

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      color: "gray",
      backgroundColor: state.isSelected ? "#01B1E3" : "#fff",
      zIndex: 9999,
    }),
  };

  // handle selection
  const handleCustomerCodeChange = (value) => {
    if (value.tblOrders[0]?.OrderId != null && value.tblOrders[0]?.OrderId != undefined) {
      navigate(`/view-edit-order/${value.tblOrders[0]?.OrderId}`)
    }
    setCustomerCodeValue(value);
    setCustomeCodeErr(false);
    setCustomerNameErr(false);
    setCustomerNameValue(value.CustomerName)
    setBuyerCode(value.BuyerCode);
    setDeliveryInstructions(value.DeliveryInstructions);
    setPoNumber(value.PurchaseOrder);
    setOrderNotes(value.OrderNotes);
    setContactName(value.CustomerName);
    setPhoneNo(value.CustomerContact);
    setcustomerId(value.value); 
    setCustomerCategory(value.Category); 
  };

  const handleOrderDetailsChange = (newOrderDetails) => {
    setOrderItemsList(newOrderDetails);
  };

  const addOrder = async (e) => {
    e.preventDefault();

    let URL = process.env.REACT_APP_API_URL + "/create-order";
    if (customerNameValue.length == 0 || customerCodeValue === "") {
      setCustomerNameErr(true);
      setCustomeCodeErr(true);
      return false;
    }
    if (orderItemsList.length == 0) {
      setOrderDErr(true);
      return false;
    }

    let payload = {
      OrderDate: orderDate,
      PurchaseOrder: poNumber,
      DeliveryInstructions: deliveryInstructions,
      OrderNotes: orderNotes,
      CustomerID: customerId,
      OrderDetails: orderItemsList,
    };
    setDisabledBtn(true);
    setMessage('');
    setMessageType('');
    let response = await POSTREQUEST(URL, payload, user.jwtToken)
    if (response?.data) {
      let data = response.data;
      if (data.success) {
        setMessage(data.message);
        setMessageType('success');
        setTimeout(() => {
          navigate("/all-orders");
        }, 2000);
      } else {
        setMessage(data.message);
        setMessageType('error');
        setDisabledBtn(false);
      }
    }
    else {
      setMessage(response?.error?.message || 'Failed to create Order !!');
      setMessageType('error');
      setDisabledBtn(false);
    }
  };

  const formatDataForWarehouse = () => {
    let data = [];
    if (orderItemsList.length > 0) {
      orderItemsList.forEach((details) => {
        let newObj = {};
        newObj.ProductID = details.ProductID;
        newObj.ProductName = details.ProductName;
        newObj.Qty = details.Qty;
        newObj.ClassName = details.ClassName;
        newObj.ProductCode = details.ProductCode;
        newObj.RRP = details.RRP;
        newObj.SizeName = details.SizeName;
        newObj.SellPrice = details.SellPrice;
        newObj.LastSellPU = details.LastSellPU;
        // setting unit
        let unitItem = units.find((unitItem) => unitItem.value == parseInt(details.UnitID));
        if (unitItem !== undefined) {
          newObj.tblUnit = { UnitID: parseInt(unitItem.value), UnitName: unitItem.label }
        }
        let agentValue = agents.find((agent) => agent.value == parseInt(details.AgentID));
        newObj.tblAgent = { AgentID: parseInt(agentValue.value), AgentCode: agentValue.label }

        //setting customer 
        newObj.tblOrder = {
          CustomerID: customerId,
          OrderDate: orderDate,
          tblCustomer: {
            CustomerCode: customerCodeValue.CustomerCode,
            BuyerCode: customerCodeValue.BuyerCode
          }

        }
        // Push newly created obj to array
        data.push(newObj);
      });
      // pass new Data array to warehousesheet generation function to get warehousesSheet
      let warehouseData = convertDataToWarehouseSheet(data);
      let totalCustomersProducts = 0;

      warehouseData = warehouseData.map((data) => {
        const newObj = { ...data, TotalProducts: data.products.length - data.addBlankRows }
        totalCustomersProducts += data.products.length;
        return newObj;

      });;
      // generate Warehouse sheet
      generateWarehousePdf(warehouseData);
    }
  }

  const CustomOption = (props) => {
    return (
      <div
        className=" css-iunu0q-option"
        style={{ backgroundColor: props.isFocused ? "#01B1E3" : "#fff", color: "gray", zIndex: 9999, padding: " 8px 12px", cursor: "default", display: "block", fontSize: "inherit", width: "100%" }}
        {...props.innerProps}
        ref={props.innerRef}
      >
        {props.label}
      </div>
    )
  }

  return (
    <React.Fragment>
      <Header />
      {message && <Toastify message={message} type={messageType} />}
      <main className="bg-lite-grey overflow-auto">
        <section className="px-4 pt-3 pb-4 overflow-hidden table-listing">
          <div className="table-elements">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item fs-15">
                  <Link
                    to="/all-orders"
                    className="text-decoration-none text-primary"
                  >
                    Orders
                  </Link>
                </li>
                <li
                  className="breadcrumb-item fs-15 active"
                  aria-current="page"
                >
                  Enter Order
                </li>
              </ol>
            </nav>
          </div>
          <div className="card border-bottom-0">
            <div className="card-header bg-white d-flex align-items-lg-center justify-content-between cpx-20 cpy-14 sticky-top flex-nowrap">
              <h1 className="title-semibold fs-24 mb-xl-0 mb-0 d-flex align-items-center text-nowrap me-5 me-xl-0">
                Enter Order
              </h1>
              <div className="filter-elements d-flex align-items-center">
                <div className="custom-group flex-nowrap mb-xl-0">
                  <label
                    htmlFor=""
                    className="pe-2 d-flex align-items-center fs-14 text-lite"
                  >
                    Code:
                  </label>
                  <div className="date position-relative cme-15">
                    <Select
                      className={customeCodeErr ? "react-select-invalid" : ""}
                      value={customerCodeValue}
                      isSearchable={true}
                      styles={customStyles}
                      options={customersCode}
                      placeholder="Select Code"
                      onChange={(e) => handleCustomerCodeChange(e)}
                      components={{ Option: CustomOption }}
                    />
                  </div>
                </div>
                <div className="custom-group flex-nowrap mb-lg-0">
                  <label
                    htmlFor=""
                    className="pe-2 d-flex align-items-center fs-14 text-lite"
                  >
                    Customer:
                  </label>
                  <div className="date position-relative cme-15">
                    <input type="text"
                      className={
                        "search form-control input-sm input-width-375 " + (customerNameErr ? "is-invalid" : "")
                      }
                      defaultValue={customerNameValue}
                      placeholder="Customer Name"
                      readOnly
                    />
                  </div>
                </div>
                <div className="custom-group flex-nowrap mb-lg-0">
                  <label
                    htmlFor=""
                    className="pe-2 d-flex align-items-center fs-14 text-lite"
                  >
                    Ship date:
                  </label>
                  <div className="position-relative" data-provide="datepicker">
                    <input
                      type="date"
                      id="datepicker"
                      className="form-control input-sm date input-datepicker"
                      placeholder="Select Date"
                      defaultValue={orderDate}
                      onChange={(e) => {
                        setOrderDate(e.target.value);
                      }}
                    />
                  </div>
                </div>
              </div>
              <div></div>
            </div>
            <div className="card-body p-4 border-bottom">
              <div className="card-table table-responsive position-relative">
                <table className="table table-form disable-field">
                  <thead>
                    <tr>
                      <td scope="col" className="width-lg-8">
                        Prod. Code
                      </td>
                      <td scope="col" className="width-lg-42">
                        Product name
                      </td>
                      <td scope="col" className="width-lg-10">
                        Qty
                      </td>
                      <td scope="col" className="width-lg-10">
                        Unit
                      </td>
                      <td scope="col" className="width-lg-10">
                        Class
                      </td>
                      <td scope="col" className="width-lg-10">
                        Size
                      </td>
                      <td scope="col" className="width-lg-10">
                        Agent
                      </td>
                    </tr>

                  </thead>

                  <tbody>
                    <EnterOrderList isCustomerSelect={customerId == ''} customerCategory={customerCategory} products={products} agents={agents} units={units} handleOrderDetailsChange={handleOrderDetailsChange} />
                  </tbody>
                </table>

              </div>
              <div className="spacer-sm-5"></div>
              {orderDErr && (
                <div className="text-danger text-center">
                  {" "}
                  Please add at least one order detail.{" "}
                </div>
              )}
              <div className="col d-flex width-lg-10 gap-1">
                <label className="d-flex align-items-center justify-content-end fs-14 text-lite text-nowrap">
                  Items :
                </label>
                <input
                  type="text"
                  className="form-control input-sm text-end"
                  placeholder="0"
                  value={orderItemsList.length}
                  disabled
                />
              </div>
              <div className="spacer-sm-4"></div>
              <form onSubmit={addOrder}>
                <div className="row">
                  <div className="col-xl-3 col-lg-4 mb-lg-0 mb-4 flex-grow-1 flex-xl-grow-0">
                    <div className="cmb-10 row gx-3 gy-2">
                      <label className="col-xl-3 d-flex align-items-center fs-14 text-lite text-nowrap justify-content-xl-end">
                        Buyer Code:
                      </label>
                      <div className="col">
                        <input
                          type="text"
                          className="form-control input-sm"
                          placeholder="Enter buyer code"
                          value={BuyerCode}
                          disabled
                        />
                      </div>
                    </div>
                    <div className="cmb-10 row gx-3 gy-2">
                      <label className="col-xl-3 d-flex align-items-center fs-14 text-lite text-nowrap justify-content-xl-end">
                        Contact name:
                      </label>
                      <div className="col">
                        <input
                          type="text"
                          className="form-control input-sm"
                          placeholder="Enter contact name"
                          value={contactName}
                          disabled
                        />
                      </div>
                    </div>
                    <div className="cmb-10 row gx-3 gy-2">
                      <label className="col-xl-3 d-flex align-items-center fs-14 text-lite text-nowrap justify-content-xl-end">
                        Phone No:
                      </label>
                      <div className="col">
                        <input
                          type="text"
                          className="form-control input-sm"
                          placeholder="Enter phone no."
                          value={phoneNo}
                          disabled
                        />
                      </div>
                    </div>
                    <div className="cmb-10 row gx-3 gy-2">
                      <label className="col-xl-3 d-flex align-items-center fs-14 text-lite text-nowrap justify-content-xl-end">
                        Purchase Order:
                      </label>
                      <div className="col">
                        <input
                          type="text"
                          className={
                            "form-control input-sm "
                          }
                          placeholder="Enter purchase order"
                          onChange={(e) => {
                            setPoNumber(e.target.value);
                          }}
                          defaultValue={poNumber}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="width-lg-20 width-sm-50 flex-grow-1 flex-xl-grow-0">
                    <label className="d-flex align-items-center fs-15 text-dark mb-1">
                      Order Notes
                    </label>
                    <textarea
                      className={
                        "form-control fw-normal fs-15 fst-italic "
                      }
                      rows="3"
                      style={{ minHeight: "81%" }}
                      placeholder="Enter notes"
                      onChange={(e) => {
                        setOrderNotes(e.target.value);
                      }}
                      defaultValue={orderNotes}
                    ></textarea>
                  </div>
                  <div className="width-lg-20 width-sm-50 flex-grow-1 flex-xl-grow-0">
                    <label className="d-flex align-items-center fs-15 text-dark mb-1">
                      Delivery Instructions
                    </label>
                    <textarea
                      className={
                        "form-control fw-normal fs-15 fst-italic "
                      }
                      rows="3"
                      style={{ minHeight: "81%" }}
                      placeholder="Enter delivery instructions"
                      onChange={(e) => {
                        setDeliveryInstructions(e.target.value);
                      }}
                      defaultValue={deliveryInstructions}
                    ></textarea>
                  </div>
                  <div className="col d-flex justify-content-end align-items-end mt-4 mt-lg-0">
                    <button disabled={orderItemsList.length === 0} type="button"
                      className={`btn btn-outline-secondary btn-md ms-auto d-flex align-items-center px-4 fw-medium rounded-3 mx-1 ${orderItemsList.length > 0 ? "" : "disabled"}`}
                      onClick={() => { formatDataForWarehouse() }}
                    >
                      Preview
                    </button>
                    <button
                      type="submit"
                      className="btn btn-md btn-secondary px-4 fw-medium text-white rounded-3 mx-1"
                      disabled={disabledBtn}
                    >
                      Save
                    </button>

                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </main>
    </React.Fragment>
  );
}

export default EnterOrder;
